import React from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import { usePictureSets } from "../../../hooks/usePictureSets";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import Container from "@mui/material/Container";
import { useAuth } from "@/react/Webshop/providers/AuthProvider";
import UserSubjectFavoritePicturesSelector from "@/react/Webshop/Components/UserSubjectFavoritePicturesSelector";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BottomBar from "@/react/Webshop/Mobile/Components/BottomBar";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(1),
    },
    list: {
        width: "100%",
        overflow: "auto",
        alignItems: "center",
        listStyle: "none",
        margin: 0,
        padding: 0,
        flexGrow: 1,
        display: "flex",
    },
    listItem: {
        position: "relative",
        "& > img": {
            width: "100%",
            height: "100%",
            objectFit: "contain",
        },
    },
    infoText: {
        color: theme.palette.primary.main,
        marginTop: 0,
        textAlign: "center",
    },
    newSetText: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        display: "inline-block",
        padding: "3px 10px 3px 10px",
        marginLeft: "-40px",
        marginBottom: theme.spacing(2),
    },
    iconContainer: {
        "& svg": {
            marginRight: theme.spacing(2),
            color: theme.palette.secondary.main,
        },
    },
    title: {
        fontSize: "30px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginBottom: 0,
        fontWeight: 300,
    },
}));
const NewPictureSetFavorites = () => {
    const { isLoaded, currentPictureSet } = usePictureSets();
    const { user } = useAuth();
    const classes = useStyles();
    const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
    console.log("Found picture set ", currentPictureSet, isLoaded);
    if (!isLoaded || !currentPictureSet || !user) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Loading..")));
    }
    const numFavorites = currentPictureSet.pictures.filter((p) => p.isUserFavorite).length;
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(FavoriteBorderIcon, { sx: { color: "primary.dark", fontSize: 65 } })),
        React.createElement("h1", { className: classes.title },
            React.createElement(Trans, null, "Select your favorites")),
        React.createElement(Container, { className: classes.root },
            React.createElement("p", { className: classes.infoText },
                React.createElement(Trans, null, "We notice you have many pictures. Please select your favorites to reduce the amount.")),
            React.createElement(UserSubjectFavoritePicturesSelector, { pictureSet: currentPictureSet, pictureContextMenuProps: getCopyrightTriggerProps() })),
        React.createElement(BottomBar, null,
            React.createElement(Container, null,
                React.createElement(Box, { display: "flex", justifyContent: "space-between", py: 1 },
                    React.createElement(Box, { display: "flex", alignItems: "center", className: classes.iconContainer },
                        React.createElement(FavoritesContainer, { numFavorites: numFavorites, totalPictures: currentPictureSet.pictures.length })),
                    React.createElement(NextButton, { pictureSet: currentPictureSet, numFavorites: numFavorites })))),
        copyrightDialog));
};
const NextButton = ({ pictureSet, numFavorites }) => {
    var _a;
    if (pictureSet.qualifyForSelectYearbookPose &&
        !((_a = pictureSet.job.yearbookPoseSelection) === null || _a === void 0 ? void 0 : _a.expired)) {
        return (React.createElement(Button, { component: Link, variant: "contained", color: "primary", to: "/new-picture-set/yearbook-pose" }, numFavorites > 0 ? React.createElement(Trans, null, "Next") : React.createElement(Trans, null, "Skip")));
    }
    return (React.createElement(Button, { component: Link, variant: "contained", color: "primary", to: "/products/packages" },
        React.createElement(Trans, null, "View offers and campaigns")));
};
function FavoritesContainer({ numFavorites, totalPictures, }) {
    if (numFavorites > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(FavoriteIcon, null),
            " ",
            React.createElement(Trans, null,
                { numSelectedFavorites: numFavorites },
                " of ",
                { totalPictures })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FavoriteBorderIcon, null),
        " ",
        React.createElement(Trans, null,
            { numSelectedFavorites: numFavorites },
            " of ",
            { totalPictures })));
}
export default NewPictureSetFavorites;
